export const XMLHttpRequest = null;